'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconShoppingCartFull = require('@cimpress-technology/react-streamline-icons/lib/IconShoppingCartFull');

var _IconShoppingCartFull2 = _interopRequireDefault(_IconShoppingCartFull);

var _IconShirtPlain = require('@cimpress-technology/react-streamline-icons/lib/IconShirtPlain');

var _IconShirtPlain2 = _interopRequireDefault(_IconShirtPlain);

var _IconDesignToolPenStation = require('@cimpress-technology/react-streamline-icons/lib/IconDesignToolPenStation');

var _IconDesignToolPenStation2 = _interopRequireDefault(_IconDesignToolPenStation);

var _IconShipmentTruck = require('@cimpress-technology/react-streamline-icons/lib/IconShipmentTruck');

var _IconShipmentTruck2 = _interopRequireDefault(_IconShipmentTruck);

var _IconShop = require('@cimpress-technology/react-streamline-icons/lib/IconShop');

var _IconShop2 = _interopRequireDefault(_IconShop);

var _IconAnalyticsPieAlt = require('@cimpress-technology/react-streamline-icons/lib/IconAnalyticsPieAlt');

var _IconAnalyticsPieAlt2 = _interopRequireDefault(_IconAnalyticsPieAlt);

var _IconUserSetting = require('@cimpress-technology/react-streamline-icons/lib/IconUserSetting');

var _IconUserSetting2 = _interopRequireDefault(_IconUserSetting);

var _IconFolderCode = require('@cimpress-technology/react-streamline-icons/lib/IconFolderCode');

var _IconFolderCode2 = _interopRequireDefault(_IconFolderCode);

var _IconBookOpen = require('@cimpress-technology/react-streamline-icons/lib/IconBookOpen');

var _IconBookOpen2 = _interopRequireDefault(_IconBookOpen);

var _IconMonitorShoppingCart = require('@cimpress-technology/react-streamline-icons/lib/IconMonitorShoppingCart');

var _IconMonitorShoppingCart2 = _interopRequireDefault(_IconMonitorShoppingCart);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var icons = {
  IconShoppingCartFull: _IconShoppingCartFull2.default,
  IconShirtPlain: _IconShirtPlain2.default,
  IconDesignToolPenStation: _IconDesignToolPenStation2.default,
  IconShipmentTruck: _IconShipmentTruck2.default,
  IconShop: _IconShop2.default,
  IconAnalyticsPieAlt: _IconAnalyticsPieAlt2.default,
  IconUserSetting: _IconUserSetting2.default,
  IconFolderCode: _IconFolderCode2.default,
  IconBookOpen: _IconBookOpen2.default,
  IconMonitorShoppingCart: _IconMonitorShoppingCart2.default
};

var NavItem = function NavItem(_ref) {
  var item = _ref.item,
      active = _ref.active,
      nested = _ref.nested,
      onClick = _ref.onClick;
  var IconComponent = item.iconComponent ? icons[item.iconComponent] : undefined;
  return _react2.default.createElement('a', {
    onClick: onClick,
    href: item.url,
    className: 'list-group-item clickable' + (active ? ' active' : '') + (nested ? ' level-two' : '')
  }, IconComponent ? _react2.default.createElement(IconComponent, {
    style: {
      marginRight: '21px'
    }
  }) : item.glyphicon ? _react2.default.createElement('i', {
    className: 'fa fa-' + item.glyphicon
  }) : item.iconUrl ? _react2.default.createElement('img', {
    src: item.iconUrl
  }) : null, item.text, item.subItems && _react2.default.createElement('i', {
    className: 'fa fa-xl fa-angle-' + (active ? 'up' : 'down') + ' pull-right'
  }));
};

NavItem.propTypes = {
  item: _propTypes2.default.object,
  active: _propTypes2.default.bool,
  nested: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};
var _default = NavItem;
exports.default = _default;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(icons, 'icons', 'src/Header/NavItem.jsx');
  reactHotLoader.register(NavItem, 'NavItem', 'src/Header/NavItem.jsx');
  reactHotLoader.register(_default, 'default', 'src/Header/NavItem.jsx');
  leaveModule(module);
})();

;